import React from "react";

const WatersVariantB = () => {
  return (
    <div className="space-y-5">
      {/* Partner Badge */}
      <div className="inline-flex items-center gap-1.5 bg-lightPurple text-purpleDark text-sm font-semibold px-3 py-1.5 rounded-full">
        <span>⭐</span> Waters Member Benefit
      </div>

      {/* Headline */}
      <div>
        <h1 className="font-montserrat text-[28px] leading-tight font-bold text-gray-900">
          SAVE <span className="text-darkPurple">$1,000+/YR</span> ON INSURANCE — AND GET PAID TO DO IT{" "}
          <span className="inline-flex items-center bg-lightPurple text-purpleDark text-xs font-bold px-2 py-0.5 rounded-md align-middle">
            NEW
          </span>
        </h1>
        <p className="text-base text-gray-600 mt-3">
          Create your free Insurance Profile once. Agencies compete for you. You keep the savings and the earnings.
        </p>
      </div>

      {/* Stats Cards with Icons */}
      <div className="flex gap-3">
        <div className="flex-1 bg-purpleMid rounded-2xl p-4">
          <span className="text-2xl">💰</span>
          <p className="font-montserrat text-3xl font-bold text-white mt-1">$1,000+</p>
          <p className="text-xs text-white/80">Avg. potential annual savings</p>
        </div>
        <div className="flex-1 bg-greenLight rounded-2xl p-4">
          <span className="text-2xl">🏆</span>
          <p className="font-montserrat text-3xl font-bold text-darkPurple mt-1">$3</p>
          <p className="text-xs text-gray-600">Earned for your data</p>
          <span className="inline-block bg-lightPurple text-purpleDark text-[10px] font-bold px-2 py-0.5 rounded mt-1 uppercase tracking-wide">
            First time ever
          </span>
        </div>
      </div>

      {/* Green Callout */}
      <div className="bg-greenish rounded-2xl p-4 animate-nudge">
        <p className="text-sm text-gray-700">
          <strong>Thousands of dollars already paid</strong> to Waters customers.
        </p>
      </div>

      {/* Steps */}
      <div className="bg-lightGrey rounded-2xl p-5">
        <h2 className="text-xs font-bold tracking-widest text-gray-900 mb-4 uppercase">
          Here's what to expect
        </h2>
        <div className="space-y-3">
          {[
            "Sign up to create your Ownli account",
            "Take a quick survey",
            "Complete your Insurance Profile",
            "Get matched with agencies & see offers",
          ].map((step, i) => (
            <div key={i} className="flex items-start gap-3">
              <span className="mt-1.5 min-w-[10px] min-h-[10px] bg-darkPurple rounded-full"></span>
              <p className="text-sm text-darkGrey">{step}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WatersVariantB;
